var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 592,
    height: 592,
    viewBox: "0 0 592 592",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_49)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 488 552)",
    fill: "#330036"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 424 552)",
    fill: "#6369D1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 360 552)",
    fill: "#0892A5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 296 552)",
    fill: "#75B9BE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 232 552)",
    fill: "#9BC53D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 168 552)",
    fill: "#FFAE03"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 104 552)",
    fill: "#E28413"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 512,
    transform: "matrix(1 0 0 -1 40 552)",
    fill: "#F45B69"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 552,
    height: 552,
    rx: 276,
    stroke: "black",
    strokeWidth: 40
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 512,
    height: 512,
    rx: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.16b24ad53c8fa70254768f5b15f32d30.svg";
export { ForwardRef as ReactComponent };